import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./OrderAddAuthorizerModal.css";

const OrderAddAuthorizerModal = ({ show, onHide, display, onUpdate }) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(display || ''); 
    }, [display]);

    const handleValueChange = (e) => {
        setValue(e.target.value);
    };

    const handleUpdate = () => {
        onUpdate(value); 
        onHide();
    };

    return (
        <Modal className="opal-add-authorizer-modal" show={show} onHide={onHide} centered>
            <Modal.Header>
                Authorized Person
            </Modal.Header>
            <Modal.Body>
                <div className="input-group">
                    <input
                        className="form-control"
                        placeholder="Input authorized person"
                        value={value}
                        onChange={handleValueChange}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="update-btn" onClick={handleUpdate}>
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OrderAddAuthorizerModal;
